import { render, staticRenderFns } from "./CompanyProfitLoss.vue?vue&type=template&id=71e173d9&"
import script from "./CompanyProfitLoss.vue?vue&type=script&lang=ts&"
export * from "./CompanyProfitLoss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports